module.exports = __webpack_public_path__ + "img/Dantam Hair 16.9e20e25a.jpg";